var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"g_id_onload","data-client_id":_vm.googleOauthClientId,"data-login_uri":_vm.loginUrl,"data-callback":"handleOneTapCredentialResponse"}})}
var staticRenderFns = []

export { render, staticRenderFns }